// @ts-nocheck
/**
 * Shared behavior for the 'standard' splash_v2 page (coinsweeps / dotycasino family).
 * Consolidated here from the per-template inline <script> blocks (identical copies).
 * Gated on [data-splash-v2] so it is a no-op on splash templates that still ship their
 * own inline scripts (elitebet/hamroplay/playaezra) and would otherwise double-bind.
 */
import '../../base/trackers';

function initSplashV2(): void {
        const hamburger=document.getElementById('hamburger');
        const drawer=document.getElementById('nav-drawer');
        const drawerClose=document.getElementById('drawer-close');
        function toggleDrawer(forceOpen=null){
            const willOpen=forceOpen!==null?forceOpen:!drawer.classList.contains('open');
            drawer.classList.toggle('open',willOpen);
            hamburger?.setAttribute('aria-expanded',willOpen?'true':'false');
            drawer?.setAttribute('aria-hidden',willOpen?'false':'true');
        }
        hamburger?.addEventListener('click',()=>toggleDrawer());
        drawerClose?.addEventListener('click',()=>toggleDrawer(false));
        drawer?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>toggleDrawer(false)));

        (function(){
            const img=document.getElementById('hero-img');
            function setOverlap(){
                if(!img) return;
                const h=img.getBoundingClientRect().height || img.clientHeight || 0;
                const overlap=h*0.20;
                document.documentElement.style.setProperty('--hero-overlap', overlap+'px');
            }
            if(img?.complete){ setOverlap(); } else { img?.addEventListener('load', setOverlap, {once:true}); }
            let rT=null;
            window.addEventListener('resize', ()=>{ clearTimeout(rT); rT=setTimeout(setOverlap, 80); });
            window.__recalcOverlap=setOverlap;
        })();

        (function(){
            function makePh(w,h,fileLabel){
                const c=document.createElement('canvas');
                const W=Math.max(160, Math.floor((w||1200)/10));
                const H=Math.max(90,  Math.floor((h||300)/10));
                c.width=W; c.height=H;
                const ctx=c.getContext('2d');
                const g=ctx.createLinearGradient(0,0,0,H);
                g.addColorStop(0,'#1a2435'); g.addColorStop(1,'#0f1724');
                ctx.fillStyle=g; ctx.fillRect(0,0,W,H);
                ctx.fillStyle='rgba(255,255,255,0.08)';
                for(let i=0;i<W;i+=16){ ctx.fillRect(i,0,8,H); }
                ctx.strokeStyle='rgba(255,255,255,0.22)'; ctx.lineWidth=1.5;
                ctx.strokeRect(4,4,W-8,H-8);
                ctx.fillStyle='#CC2424';
                ctx.textAlign='center'; ctx.textBaseline='middle';
                ctx.font='bold '+Math.floor(H*0.24)+'px Figtree,Arial';
                ctx.fillText(fileLabel||'image.png', W/2, H/2);
                return c.toDataURL('image/png');
            }
            function injectPlaceholders(){
                const els=[...document.querySelectorAll('img.png-ph')];
                els.forEach(img=>{
                    const parent=img.parentElement;
                    const box=parent?.getBoundingClientRect?.()||{width:1200,height:300};
                    const label=(img.dataset.phFile||'image.png').trim();
                    const url=makePh(box.width, box.height, label);
                    if(img.dataset.forcePlaceholder==='true' || !img.dataset.phApplied){
                        img.src=url;
                        img.dataset.phApplied='1';
                    }
                    img.onerror=()=>{ img.onerror=null; img.src=url; img.dataset.phApplied='1'; };
                });
                if(window.__recalcOverlap) window.__recalcOverlap();
            }
            document.addEventListener('DOMContentLoaded', injectPlaceholders);
            window.addEventListener('resize',()=>{ clearTimeout(window.__phRT); window.__phRT=setTimeout(injectPlaceholders,90); });
        })();

        (function(){
            const viewport=document.getElementById('prov-viewport');
            const row=document.getElementById('providers-row');
            const prev=document.getElementById('prov-prev');
            const next=document.getElementById('prov-next');
            if(!viewport||!row) return;
            if(row.children.length < 2){
                prev?.setAttribute('hidden', 'hidden');
                next?.setAttribute('hidden', 'hidden');
                return;
            }

            function normalize(){
                const half=row.scrollWidth/2;
                if(half <= 0) return;
                if(viewport.scrollLeft>=half) viewport.scrollLeft-=half;
                if(viewport.scrollLeft<=0)   viewport.scrollLeft+=half;
            }
            function stepSize(){ return Math.max(220, viewport.clientWidth*0.6); }
            function go(dir=1){ viewport.scrollBy({left:dir*stepSize(),behavior:'smooth'}); setTimeout(normalize,500); }

            let timer=setInterval(()=>go(1),4000);
            function reset(){ clearInterval(timer); timer=setInterval(()=>go(1),4000); }

            prev?.addEventListener('click',()=>{ go(-1); reset(); });
            next?.addEventListener('click',()=>{ go(1);  reset(); });

            ['mouseenter','focusin'].forEach(ev=>viewport.addEventListener(ev,()=>clearInterval(timer)));
            ['mouseleave','focusout'].forEach(ev=>viewport.addEventListener(ev,()=>reset()));
            viewport.scrollLeft=row.scrollWidth/2;
        })();

        (function(){
            const track=document.getElementById('games-track');
            const prev=document.getElementById('games-prev');
            const next=document.getElementById('games-next');
            if(!track) return;
            const container=document.getElementById('games-viewport');
            const initialCards=[...track.querySelectorAll('.game-card')].map(card=>card.cloneNode(true));
            const emptyStateMarkup=track.innerHTML;
            let slides=[];
            let idx=0;
            let t=null;

            function perSlide(){
                const w=window.innerWidth;
                if(w <= 480) return 6;
                if(w <= 900) return 9;
                return 12;
            }

            function rebuildSlides(){
                if(initialCards.length === 0){
                    track.innerHTML=emptyStateMarkup;
                    slides=[...track.children];
                    prev?.setAttribute('hidden', 'hidden');
                    next?.setAttribute('hidden', 'hidden');
                    return;
                }

                track.innerHTML='';
                const size=perSlide();
                for(let i=0; i<initialCards.length; i+=size){
                    const slide=document.createElement('div');
                    slide.className='games-slide';
                    const grid=document.createElement('div');
                    grid.className='games-grid';
                    initialCards.slice(i,i+size).forEach(card=>grid.appendChild(card.cloneNode(true)));
                    slide.appendChild(grid);
                    track.appendChild(slide);
                }

                slides=[...track.children];
                if(slides.length === 1){
                    track.appendChild(slides[0].cloneNode(true));
                    track.appendChild(slides[0].cloneNode(true));
                    slides=[...track.children];
                }

                if(slides.length <= 1){
                    prev?.setAttribute('hidden', 'hidden');
                    next?.setAttribute('hidden', 'hidden');
                } else {
                    prev?.removeAttribute('hidden');
                    next?.removeAttribute('hidden');
                }

                idx=0;
                track.style.transform='translateX(0)';
            }

            function go(n){
                if(slides.length === 0) return;
                idx=(n+slides.length)%slides.length;
                track.style.transform=`translateX(${-idx*100}%)`;
            }
            function n(){ go(idx+1); }
            function p(){ go(idx-1); }
            prev?.addEventListener('click',()=>{ p(); reset(); });
            next?.addEventListener('click',()=>{ n(); reset(); });
            function reset(){
                clearInterval(t);
                if(slides.length > 1){
                    t=setInterval(n,4000);
                }
            }
            if(container){
                ['mouseenter','focusin'].forEach(ev=>container.addEventListener(ev,()=>clearInterval(t)));
                ['mouseleave','focusout'].forEach(ev=>container.addEventListener(ev,()=>reset()));
            }
            rebuildSlides();
            reset();
            window.addEventListener('resize', ()=>{
                clearTimeout(window.__gamesRebuildRT);
                window.__gamesRebuildRT=setTimeout(()=>{
                    rebuildSlides();
                    reset();
                },80);
            });
        })();

        (function(){
            const track=document.getElementById('car-track');
            if(!track) return;
            const slides=[...track.children];
            const prevBtn=document.querySelector('.car-btn.prev');
            const nextBtn=document.querySelector('.car-btn.next');
            let idx=0;
            function go(n){ idx=(n+slides.length)%slides.length; track.style.transform=`translateX(${-idx*100}%)`; }
            prevBtn?.addEventListener('click', () => go(idx-1));
            nextBtn?.addEventListener('click', () => go(idx+1));
            setInterval(() => go(idx+1), 8000);
        })();

        (function(){
            function syncSideIllHeights(){
                const desktop = window.innerWidth > 900;
                document.querySelectorAll('.side-ill').forEach(block=>{
                    const content = block.querySelector('.side-content');
                    const img = block.querySelector('.side-media img');
                    if(!content || !img) return;

                    img.style.height='';
                    img.style.maxHeight='';

                    if(!desktop){
                        return;
                    }

                    const rect = content.getBoundingClientRect();
                    if(rect.height > 0){
                        const target = rect.height * 1.0;
                        img.style.height = target + 'px';
                        img.style.maxHeight = target + 'px';
                    }
                });
            }

            window.addEventListener('load', syncSideIllHeights);
            window.addEventListener('resize', ()=>{
                clearTimeout(window.__sideIllRT);
                window.__sideIllRT = setTimeout(syncSideIllHeights, 80);
            });

            document.querySelectorAll('.side-ill .side-media img').forEach(img=>{
                if(!img.complete){
                    img.addEventListener('load', syncSideIllHeights, {once:true});
                }
            });

            window.__syncSideIllHeights = syncSideIllHeights;
        })();

        (function(){
            function syncApkIllustration(){
                const desktop = window.innerWidth > 960;
                const steps = document.querySelector('.apk-steps');
                const img = document.querySelector('.download-ill .ph img');
                if(!steps || !img) return;

                img.style.height='';
                img.style.maxHeight='';

                if(!desktop) return;

                const rect = steps.getBoundingClientRect();
                if(rect.height > 0){
                    img.style.height = rect.height + 'px';
                    img.style.maxHeight = rect.height + 'px';
                }
            }

            window.addEventListener('load', syncApkIllustration);
            window.addEventListener('resize', ()=>{
                clearTimeout(window.__apkRT);
                window.__apkRT = setTimeout(syncApkIllustration,80);
            });

            const apkImg = document.querySelector('.download-ill .ph img');
            if(apkImg && !apkImg.complete){
                apkImg.addEventListener('load', syncApkIllustration, {once:true});
            }

            window.__syncApkIllustration = syncApkIllustration;
        })();

        (function(){
            function syncStepHeights(){
                const stepCards = document.querySelectorAll('.step-card');
                const apkCards  = document.querySelectorAll('.apk-step');
                if(!stepCards.length || !apkCards.length) return;

                stepCards.forEach(c => c.style.height = '');
                apkCards.forEach(c  => c.style.height = '');

                const isDesktop = window.innerWidth > 900;
                if(!isDesktop){
                    return;
                }

                let maxH = 0;
                stepCards.forEach(c =>{
                    const h = c.getBoundingClientRect().height;
                    if(h > maxH) maxH = h;
                });
                apkCards.forEach(c =>{
                    const h = c.getBoundingClientRect().height;
                    if(h > maxH) maxH = h;
                });

                if(maxH > 0){
                    stepCards.forEach(c => c.style.height = maxH + 'px');
                    apkCards.forEach(c  => c.style.height = maxH + 'px');
                }
            }

            window.addEventListener('load', syncStepHeights);
            window.addEventListener('resize', ()=>{
                clearTimeout(window.__stepsRT);
                window.__stepsRT = setTimeout(syncStepHeights, 80);
            });

            window.__syncStepHeights = syncStepHeights;
        })();

        document.querySelectorAll('.accordion-header').forEach(h=>{
            h.addEventListener('click',()=>{
                const body=h.nextElementSibling;
                const open=h.classList.toggle('active');
                body.classList.toggle('expanded',open);
                if(open){ body.style.maxHeight=body.scrollHeight+'px'; }
                else   { body.style.maxHeight=null; }
            });
        });
}

if (document.querySelector('[data-splash-v2]')) {
    initSplashV2();
}
